import { useLocaleState } from 'react-admin';

/**
 * Map react-admin locale identifiers to BCP 47 locale tags
 * used by Intl.DateTimeFormat / toLocaleString.
 */
const localeMap: Record<string, string> = {
  'pt-br': 'pt-BR',
  en: 'en-US',
};

/**
 * Returns the current app locale as a BCP 47 tag suitable for
 * Date.toLocaleString / Intl.DateTimeFormat.
 */
export function useAppLocale(): string {
  const [locale] = useLocaleState();
  return localeMap[locale] ?? locale;
}
